<template>
  <div v-if="settlementDetails" class="rounded-lg border border-gray-200 overflow-hidden bg-white">
    <div class="p-6">
      <h2 class="text-lg font-semibold text-gray-900">Orders</h2>
    </div>
    <div class="border-t border-gray-200">
      <table class="w-full table-auto text-sm text-left">
        <thead class="bg-grey-light-100 text-grey-light-600 font-medium border-b border-gray-200">
          <tr>
            <th class="px-4 py-2">Reference</th>
            <th class="px-4 py-2">State</th>
            <th class="px-4 py-2">Customer</th>
            <th class="px-4 py-2 text-right">Settlement Amount</th>
            <th class="px-4 py-2 text-right">Total Fees - Incl VAT</th>
            <th class="px-4 py-2 text-right">Total Amount</th>
          </tr>
        </thead>
        <tbody class="text-grey-light-600">
          <template v-if="settlementDetails?.feesPerOrder?.length > 0">
            <tr v-for="(order, index) in settlementDetails?.feesPerOrder" :key="index" class="border-b border-gray-200">
              <td class="p-5">{{ order.order.reference }}</td>
              <td class="p-5">{{ order.order.state }}</td>
              <td class="p-5">{{ order.order.initiator.name || 'Anonymous' }}</td>
              <td class="p-5 text-right">{{ calculateFees(order.settlementAmount, order.amountTotal) }}</td>
              <td class="p-5 text-right">{{ currency(order.amountTotal) }}</td>
              <td class="p-5 text-right">{{ currency(order.settlementAmount) }}</td>
            </tr>
          </template>
          <tr>
            <td class="p-5 text-gray-900 font-semibold">Total Amount</td>
            <td></td>
            <td></td>
            <td class="p-5 text-gray-900 font-semibold text-right">
              {{ calculateFees(settlementDetails.feesPerOrderSettlementAmount, settlementDetails.feesPerOrderTotal) }}
            </td>
            <td class="p-5 text-gray-900 font-semibold text-right">
              {{ currency(settlementDetails.feesPerOrderTotal) }}
            </td>
            <td class="p-5 text-gray-900 font-semibold text-right">
              {{ currency(settlementDetails.feesPerOrderSettlementAmount) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Settlement } from '@/models/settlements';
import { currency } from '@/utils/format.utils';

defineProps<{
  settlementDetails: Settlement | undefined;
}>();

const calculateFees = (valueOne: number, valueTwo: number) => {
  return currency(valueOne - valueTwo);
};
</script>
